import * as React from "react"
import { Button, Row, Col, Form } from "react-bootstrap"
import { Typeahead } from "react-bootstrap-typeahead"
import 'react-bootstrap-typeahead/css/Typeahead.css'
import { FaAngleDown } from "react-icons/fa"
import { Subscription } from "rxjs"
import MaskedInput from "react-maskedinput"
import PhoneNumberMaskedInput from "./FormattedInputs/PhoneNumberMaskedInput"
import StateSelect from "./FormattedInputs/StateSelect"
import AutoFilterCompaniesGet from "../api/Companies/AutoFilterCompaniesGet"
import AutoFilterCompany from "../api/Companies/CompanyModel/AutoFilterCompany"
import AutoFilterLocation from "../api/Location/LocationModel/AutoFilterLocation"
import AutoFilterLocationsGet, { AutoFilterLocationWithRegionGetObservable } from "../api/Location/AutoFilterLocationsGet"
import AutoFilterRegion from "../api/Regions/Model/AutoFilterRegion"
import AutoFilterRegionsGet from "../api/Regions/AutoFilterRegionsGet"
import { StateObservable } from "../api/OrderRequests/OrderRequestsConstraintGet"
import EmploymentDetailsEdit from "../api/Randoms/RandomPersonnelModel/EmploymentDetailsEdit"
import State from "../api/OrderRequests/OrderRequestsModel/State"
import FormatSSN from "../formatters/FormatSSN"
import FormatZipCode from "../formatters/FormatZipCode"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { EmailRegexp, PhoneRegexp } from "../config/Constants"
import { BirthdayInput } from "./FormattedInputs/BirthdayInput"
import ActionButton from "./ActionButton"
import { AppState } from "../AppState"
import { connect } from "react-redux"
import { GetSelectedAssignedClinic } from "../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import CompanyInput from "./FormattedInputs/CompanyInput"
import RegulatoryMode from "../api/LabService/LabServiceModel/RegulatoryMode"
import Category from "../api/LabService/LabServiceModel/EmployeeCategory"
import LabServiceRegulatoryModesGetObservable from "../api/LabService/LabServiceRegulatoryModesGet"
import FormatError from "../formatters/FormatError"
import { toast } from "react-toastify"
import EmployeeCategoriesGetObservable from "../api/LabService/EmployeeCategoriesGet"
import { PoolRegulatoryMode } from "../api/Randoms/RandomsModel/PoolCompanyInfo"

interface EmploymentDetailsAuthProps {
  isLocation?: boolean
}

interface EmploymentDetailsProps {
  data: EmploymentDetailsEdit
  isSaving: boolean
  onSave: (data: EmploymentDetailsEdit) => void
  onCancel: () => void
}

interface EmploymentDetailsValidity {
  isCompanyValid: boolean
  isLastNameValid: boolean
  isFirstNameValid: boolean
  isEmployerIDValid: boolean
  isSSNValid: boolean
  isDriverIDValid: boolean
  isAlternateIDValid: boolean
  isWorkPhoneValid: boolean
  isHomePhoneValid: boolean
  isMobilePhoneValid: boolean
  isEmailValid: boolean
  isRegulatoryModeValid: boolean
  isCategoryValid: boolean
}

interface EmploymentDetailsState extends EmploymentDetailsEdit, EmploymentDetailsValidity {
  companyTypeaheadKey: string
  regionTypeaheadKey: string
  locationTypeaheadKey: string
  isCompaniesLoading: boolean
  isRegionsLoading: boolean
  isStatesLoading: boolean
  isLocationsLoading: boolean
  regions: AutoFilterRegion[]
  nonRegionLocations: AutoFilterLocation[]
  locations: AutoFilterLocation[]
  companiesDetails: AutoFilterCompany[]
  states: State[]
  availableRegulatoryModes: PoolRegulatoryMode[]
  isRegulatoryModesLoading: boolean
  availableCategories: Category[]
  isCategoriesLoading: boolean
}

interface Gender {
  Name: string
  Code: string
}

const genders: Gender[] = [{ Name: "Male", Code: "M" }, { Name: "Female", Code: "F" }]

export class EmploymentDetails extends React.Component<EmploymentDetailsProps & EmploymentDetailsAuthProps, EmploymentDetailsState> {
  defaultState: EmploymentDetailsState = {
    companyTypeaheadKey: "company",
    regionTypeaheadKey: "region",
    locationTypeaheadKey: "location",
    isCompaniesLoading: false,
    isRegionsLoading: false,
    isLocationsLoading: false,
    isStatesLoading: false,
    nonRegionLocations: [],
    regions: [],
    locations: [],
    companiesDetails: [],
    isCompanyValid: true,
    isLastNameValid: true,
    isFirstNameValid: true,
    isEmployerIDValid: true,
    isSSNValid: true,
    isDriverIDValid: true,
    isAlternateIDValid: true,
    isWorkPhoneValid: true,
    isHomePhoneValid: true,
    isMobilePhoneValid: true,
    isEmailValid: true,
    isRegulatoryModeValid: true,
    isCategoryValid: true,
    Employer: "",
    Driver: "",
    SSN: "",
    Alternate: "",
    Occupation: "",
    Inactive: false,
    FirstName: "",
    LastName: "",
    Address1: "",
    Address2: "",
    City: "",
    Zip: "",
    Province: "",
    WPhone: "",
    HPhone: "",
    CPhone: "",
    Email: "",
    Gender: "",
    states: [],
    state: undefined,
    isRegulatoryModesLoading: false,
    availableRegulatoryModes: [],
    selectedRegulatoryMode: undefined,
    isCategoriesLoading: false,
    availableCategories: [],
    selectedCategory: undefined
  }
  state: EmploymentDetailsState = { ...this.defaultState }

  subscriptions = new Subscription()

  regionTypeahead = React.createRef<Typeahead<AutoFilterRegion>>()
  locationTypeahead = React.createRef<Typeahead<AutoFilterLocation>>()
  genderTypeahead = React.createRef<Typeahead<Gender>>()
  hiredate = React.createRef<DatePicker>()
  birthdate = React.createRef<DatePicker>()
  regulatoryModeTypeahead = React.createRef<Typeahead<PoolRegulatoryMode>>()
  categoryTypeahead= React.createRef<Typeahead<Category>>()

  componentDidMount() {
    this.setState({ isCompaniesLoading: true, isStatesLoading: true })

    this.subscriptions.add(
      AutoFilterCompaniesGet("").subscribe(
        data => {
          const selectedCompany = data.length > 1 ? undefined : data[0]
          this.setState({ companiesDetails: data, isCompaniesLoading: false, selectedCompany: selectedCompany })
        },
        () => this.setState({ isCompaniesLoading: false })
      )
    )

    this.subscriptions.add(
      StateObservable().subscribe(
        (results: State[]) => this.setState({ states: results, isStatesLoading: false }),
        () => { this.setState({ isStatesLoading: false }) }
      )
    )

    this.subscriptions.add(LabServiceRegulatoryModesGetObservable().subscribe(
      (data: RegulatoryMode[]) => {
        const convertedRegs: PoolRegulatoryMode[] = data.map(item => ({
          ID: item.RegulatoryModeID,
          Description: item.Name
        }));
        this.setState({
          availableRegulatoryModes: convertedRegs,
          isRegulatoryModesLoading: false
        })
      },
      (error) => {
        toast.error(FormatError(error)),
        this.setState({ isRegulatoryModesLoading: false })
      }
    ))

  }

  componentWillUnmount() {
    this.subscriptions.unsubscribe()
  }

  loadAllRegions = (company?: AutoFilterCompany) => {
    this.setState({ isRegionsLoading: true })
    this.subscriptions.add(
      AutoFilterRegionsGet(company?.AccountID || 0, "").subscribe(
        data => this.setState({
          regions: data,
          isRegionsLoading: false,
          regionTypeaheadKey: Math.random().toString()
        }),
        () => this.setState({ isRegionsLoading: false })
      )
    )
  }

  loadAllLocations = (company?: AutoFilterCompany, region?: AutoFilterRegion) => {
    this.setState({ isLocationsLoading: true })
    this.subscriptions.add(
      AutoFilterLocationsGet(company?.AccountID || 0, region?.Code || "", "").subscribe(
        data => {
        if (this.props.isLocation) {
          this.setState({locations: data, nonRegionLocations: data, isLocationsLoading: false, selectedLocation: data[0]})
        }
        else {
          this.setState({locations: data, nonRegionLocations: data, isLocationsLoading: false, locationTypeaheadKey: Math.random().toString()
          })
        }
      },
        () => this.setState({ isLocationsLoading: false })
      )
    )
  }

  loadLocationsWithRegion = (company?: AutoFilterCompany, region?: AutoFilterRegion) => {
    this.setState({ isLocationsLoading: true })
    this.subscriptions.add(
      AutoFilterLocationWithRegionGetObservable(region?.AccountID || 0, "").subscribe(
        data => this.setState({
          locations: data,
          isLocationsLoading: false,
          locationTypeaheadKey: Math.random().toString()
        }),
        () => this.setState({ isLocationsLoading: false })
      )
    )
  }

  loadCategories = (regulatoryMode: PoolRegulatoryMode) => {
    this.setState({ isCategoriesLoading: true })
    this.subscriptions.add(
      EmployeeCategoriesGetObservable(regulatoryMode.ID).subscribe(
        categories => this.setState({ availableCategories: categories, isCategoriesLoading: false }),
        () => this.setState({ isCategoriesLoading: false })
      )
    )
  }

  ssnRequired = () => this.state.selectedCompany?.PrimaryIDType === "SSN"
  employerIDRequired = () => this.state.selectedCompany?.PrimaryIDType === "EmployerID"
  driverIDRequired = () => this.state.selectedCompany?.PrimaryIDType === "DriverID"
  alternateIDRequired = () => this.state.selectedCompany?.PrimaryIDType === "AlternateID"

  isEmailValid = (value: string) => {
    if (value.length === 0) {
      return true
    }
    return EmailRegexp.test(value)
  }

  isPhoneValid = (value: string) => value.length === 0 || PhoneRegexp.test(value) || value.toLowerCase() === "n/p"
  isNotEmpty = (value: string, required: boolean) => !required || value.trim().length > 0
  isSSNValid = (value: string, required: boolean) => (!required && value.length === 0) || value.replace(/\D/g, "").length === 9

  isValid = (state: EmploymentDetailsValidity) => {
    return state.isCompanyValid && state.isLastNameValid && state.isFirstNameValid
      && state.isEmployerIDValid && state.isSSNValid && state.isDriverIDValid && state.isAlternateIDValid
      && state.isEmailValid && state.isWorkPhoneValid && state.isHomePhoneValid && state.isMobilePhoneValid
  }

  handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    const changes: EmploymentDetailsValidity = {
      isCompanyValid: !!this.state.selectedCompany,
      isLastNameValid: this.state.LastName.trim().length > 0,
      isFirstNameValid: this.state.FirstName.trim().length > 0,
      isEmployerIDValid: this.isNotEmpty(this.state.Employer, this.employerIDRequired()),
      isSSNValid: this.isSSNValid(this.state.SSN, this.ssnRequired()),
      isDriverIDValid: this.isNotEmpty(this.state.Driver, this.driverIDRequired()),
      isAlternateIDValid: this.isNotEmpty(this.state.Alternate, this.alternateIDRequired()),
      isEmailValid: this.isEmailValid(this.state.Email),
      isWorkPhoneValid: this.isPhoneValid(this.state.WPhone),
      isHomePhoneValid: this.isPhoneValid(this.state.HPhone),
      isMobilePhoneValid: this.isPhoneValid(this.state.CPhone),
      isRegulatoryModeValid: !!this.state.selectedRegulatoryMode,
      isCategoryValid: !!this.state.selectedCategory
    }
    const isValid = this.isValid(changes)

    if (isValid) {
      this.props.onSave(this.state as EmploymentDetailsEdit)
    } else {
      this.setState(changes)
    }
  }

  handleClose = () => {
    this.setState({ ...this.defaultState })
    this.props.onCancel()
  }

  handleCompanyChange = (companies: AutoFilterCompany[]) => {
    if (companies.length > 0) {
      let selectedCompany = this.state.companiesDetails.find(i => i.AccountID === companies[0].AccountID )

      if (!["SSN", "EmployerID", "DriverID", "AlternateID"].includes(companies[0].Name))
        {
          this.subscriptions.add(
            AutoFilterCompaniesGet(companies[0].Name).subscribe(
              data => {
                selectedCompany = data.length > 1 ? selectedCompany : data[0]
                this.setState({isCompaniesLoading: false, selectedCompany: selectedCompany})
                this.loadAllRegions(selectedCompany)
                this.loadAllLocations(selectedCompany, undefined)
              },
              () => this.setState({ isCompaniesLoading: false })
            )
          )
        }

      this.setState({
        selectedCompany: selectedCompany,
        isCompanyValid: true,
        isSSNValid: true,
        isEmployerIDValid: true,
        isDriverIDValid: true,
        isAlternateIDValid: true,
        selectedRegion: undefined,
        selectedLocation: undefined,
        companyTypeaheadKey: Math.random().toString()
      })
      this.loadAllRegions(selectedCompany)
      this.loadAllLocations(selectedCompany, undefined)
    } else {
      this.setState({
        isRegionsLoading: false,
        regions: [],
        nonRegionLocations: [],
        locations: [],
        isSSNValid: true,
        isEmployerIDValid: true,
        isDriverIDValid: true,
        isAlternateIDValid: true,
        selectedCompany: undefined,
        selectedRegion: undefined,
        selectedLocation: undefined,
        isCompanyValid: false
      })
    }
  }

  handleRegionChange = (regions: AutoFilterRegion[]) => {
    if (regions.length > 0) {
      this.setState({
        selectedRegion: regions[0],
        selectedLocation: undefined,
        regionTypeaheadKey: Math.random().toString()
      })

      this.loadLocationsWithRegion(this.state.selectedCompany, regions[0])
    } else {
      this.setState({
        isLocationsLoading: false,
        locations: this.state.nonRegionLocations,
        selectedRegion: undefined,
        selectedLocation: undefined
      })
    }
  }

  handleRegulatoryModeChange = (items: PoolRegulatoryMode[]) => {
    if (items.length > 0) {
      this.setState({ selectedRegulatoryMode: items[0], selectedCategory: undefined, isRegulatoryModeValid: true })
      this.loadCategories(items[0])
    } else {
      this.setState({selectedRegulatoryMode: undefined, selectedCategory: undefined })
    }
  }

  handleCategoryChange = (items: Category[]) => this.setState({ selectedCategory: items[0], isCategoryValid: (items.length > 0 ? true : false) })

  handleLocationChange = (locations: AutoFilterLocation[]) => this.setState({ selectedLocation: locations[0], locationTypeaheadKey: Math.random().toString() })
  handlePhoneChange = (value: string, stateKey: string, stateValidKey: string) => this.setState({ ...{}, [stateKey]: value, [stateValidKey]: this.isPhoneValid(value) })
  handleStateChange = (state: State) => this.setState({ state: state })

  render() {
    const employerIDRequired = this.employerIDRequired()
    const driverIDRequired = this.driverIDRequired()
    const ssnRequired = this.ssnRequired()
    const alternateIDRequired = this.alternateIDRequired()

    return <Form onSubmit={this.handleFormSubmit}>
      <Row><Col><h5>EMPLOYMENT INFO</h5></Col></Row>
      <Form.Row className={`form-group ${employerIDRequired ? "required" : ""}`}>
        <Form.Label column sm={3}>EMPLOYER ID</Form.Label>
        <Col md={9}>
          <Form.Control type="text" isInvalid={!this.state.isEmployerIDValid} value={this.state.Employer} onChange={(e) => { this.setState({ Employer: e.target.value, isEmployerIDValid: this.isNotEmpty(e.target.value, employerIDRequired) }) }} />
        </Col>
      </Form.Row>
      <Form.Row className={`form-group ${driverIDRequired ? "required" : ""}`}>
        <Form.Label column sm={3}>DRIVER ID</Form.Label>
        <Col md={9}>
          <Form.Control type="text" isInvalid={!this.state.isDriverIDValid} value={this.state.Driver} onChange={(e) => { this.setState({ Driver: e.target.value, isDriverIDValid: this.isNotEmpty(e.target.value, driverIDRequired) }) }} />
        </Col>
      </Form.Row>
      <Form.Row className={`form-group ${ssnRequired ? "required" : ""}`}>
        <Form.Label column sm={3}>SSN</Form.Label>
        <Col md={9}>
          <Form.Control type="text"
            as={MaskedInput}
            mask="111-11-1111"
            value={this.state.SSN}
            onChange={(e) => {
              const ssn = FormatSSN(e.target.value)
              this.setState({ SSN: ssn, isSSNValid: this.isSSNValid(ssn, ssnRequired) })
            }}
            isInvalid={!this.state.isSSNValid} />
        </Col>
      </Form.Row>
      <Form.Row className={`form-group ${alternateIDRequired ? "required" : ""}`}>
        <Form.Label column sm={3}>ALTERNATE ID</Form.Label>
        <Col md={9}>
          <Form.Control type="text" isInvalid={!this.state.isAlternateIDValid} value={this.state.Alternate} onChange={(e) => { this.setState({ Alternate: e.target.value, isAlternateIDValid: this.isNotEmpty(e.target.value, alternateIDRequired) }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group required">
        <Form.Label column sm={3}>COMPANY</Form.Label>
        { this.state.companiesDetails.length <= 1 && <Row><Col md={9}>{this.state.companiesDetails[0]?.Name}</Col></Row> }
        { this.state.companiesDetails.length > 1 &&
          <Col md={9}>
            <CompanyInput filter onChange={ this.handleCompanyChange } placeholder="Select" />
          </Col>}
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>REGION</Form.Label>
        {!this.state.isRegionsLoading && this.state.regions.length === 0 && <Form.Label column sm={9}>None</Form.Label>}
        {(this.state.isRegionsLoading || this.state.regions.length > 0) &&
          <Col md={9}>
            <div className="typeahead">
              <Typeahead id="region"
                key={this.state.regionTypeaheadKey}
                ref={this.regionTypeahead}
                labelKey="Name"
                filterBy={(option, props) => props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
                isLoading={this.state.isRegionsLoading}
                onChange={this.handleRegionChange}
                options={this.state.regions}
                selected={this.state.selectedRegion ? [this.state.selectedRegion] : []}
                emptyLabel="No Regions Found"
                placeholder="Select"
                inputProps={{ autoComplete: "chrome-off" }}>
                {!this.state.isRegionsLoading &&
                  <Button variant="toggle" onClick={() => { this.regionTypeahead?.current?.toggleMenu() }}>
                    <FaAngleDown />
                  </Button>}
              </Typeahead>
            </div>
          </Col>}
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>LOCATION</Form.Label>
        {!this.state.isLocationsLoading && this.state.locations.length === 0 && <Form.Label column sm={9}>None</Form.Label>}
        {!this.state.isLocationsLoading && this.props.isLocation &&
          <Col md={9}><Form.Control type="text" value={this.state.selectedLocation?.Name || ""} disabled={true} onChange={() => { }} /></Col>}
        {(this.state.isLocationsLoading || this.state.locations.length > 0) && !this.props.isLocation &&
          <Col md={9}>
            <div className="typeahead">
              <Typeahead id="location"
                key={this.state.locationTypeaheadKey}
                ref={this.locationTypeahead}
                labelKey="Name"
                filterBy={(option, props) => props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
                isLoading={this.state.isLocationsLoading}
                onChange={this.handleLocationChange}
                options={this.state.locations}
                selected={this.state.selectedLocation ? [this.state.selectedLocation] : []}
                emptyLabel="No Locations Found"
                placeholder="Select">
                {!this.state.isLocationsLoading &&
                  <Button variant="toggle" onClick={() => { this.locationTypeahead?.current?.toggleMenu() }}>
                    <FaAngleDown />
                  </Button>}
              </Typeahead>
            </div>
          </Col>}
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>OCCUPATION</Form.Label>
        <Col md={9}>
          <Form.Control type="text" value={this.state.Occupation} onChange={(e) => { this.setState({ Occupation: e.target.value }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>HIRE DATE</Form.Label>
        <Col md={9}>
          <DatePicker className="form-control"
            ref={this.hiredate}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            maxDate={new Date()}
            selected={this.state.HireDate as Date}
            enableTabLoop={false}
            onKeyDown={(e) => { if (this.hiredate && this.hiredate.current && e.key === 'Tab') { this.hiredate.current.setOpen(false) } }}
            onChange={date => this.setState({ HireDate: date as Date || undefined })}
            customInput={<BirthdayInput />} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>INACTIVE</Form.Label>
        <Col md={9}>
          <Form.Check checked={this.state.Inactive} onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ Inactive: e.target.checked })} label="" id="personnel_inactive" className="mt-2" />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>REGULATORY MODE</Form.Label>
        {!this.state.isRegulatoryModesLoading && this.state.availableRegulatoryModes.length === 0 && <Form.Label column sm={9}>LOADING...</Form.Label>}
        {(this.state.isRegulatoryModesLoading || this.state.availableRegulatoryModes.length > 0) &&
          <Col md={9}>
            <Typeahead id="regMode"
              ref={this.regulatoryModeTypeahead}
              labelKey="Description"
              filterBy={(option, props) => props.selected.length > 0 || option?.Description.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
              onChange={this.handleRegulatoryModeChange}
              disabled={this.state.isRegulatoryModesLoading}
              isInvalid={!this.state.isRegulatoryModeValid}
              options={this.state.availableRegulatoryModes}
              selected={this.state.selectedRegulatoryMode ? [this.state.selectedRegulatoryMode] : []}
              emptyLabel="No Regulatory Modes Found"
              placeholder="Select">
              <Button variant="toggle" onClick={() => { this.regulatoryModeTypeahead.current?.toggleMenu() }}>
                <FaAngleDown />
              </Button>
            </Typeahead>
          </Col>}
      </Form.Row>
        <Form.Row className="form-group">
          <Form.Label column sm={3}>CATEGORY</Form.Label>
          {!this.state.isCategoriesLoading && this.state.availableCategories.length === 0 && <Form.Label column sm={9}>None</Form.Label>}
          {(this.state.isCategoriesLoading || this.state.availableCategories.length > 0) &&
            <Col md={9}>
              <Typeahead id="category"
                ref={this.categoryTypeahead}
                labelKey="Name"
                filterBy={(option, props) => props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
                onChange={this.handleCategoryChange}
                disabled={this.state.isCategoriesLoading}
                isInvalid={!this.state.isCategoryValid}
                options={this.state.availableCategories}
                selected={this.state.selectedCategory ? [this.state.selectedCategory] : []}
                emptyLabel="No Categories Found"
                placeholder="Select">
                <Button variant="toggle" onClick={() => { this.categoryTypeahead.current?.toggleMenu() }}>
                  <FaAngleDown />
                </Button>
              </Typeahead>
            </Col>}
        </Form.Row>
      <Row><Col><h5>GENERAL</h5></Col></Row>
      <Form.Row className="form-group required">
        <Form.Label column sm={3}>FIRST NAME</Form.Label>
        <Col md={9}>
          <Form.Control type="text" isInvalid={!this.state.isFirstNameValid} maxLength={20} value={this.state.FirstName} onChange={(e) => { this.setState({ FirstName: e.target.value, isFirstNameValid: e.target.value.trim().length > 0 }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group required">
        <Form.Label column sm={3}>LAST NAME</Form.Label>
        <Col md={9}>
          <Form.Control type="text" isInvalid={!this.state.isLastNameValid} maxLength={20} value={this.state.LastName} onChange={(e) => { this.setState({ LastName: e.target.value, isLastNameValid: e.target.value.trim().length > 0 }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>GENDER</Form.Label>
        <Col md={9}>
          <div className="typeahead">
            <Typeahead id="gender"
              ref={this.genderTypeahead}
              labelKey="Name"
              filterBy={(option, props) => props.selected.length > 0 || option.Name.toLowerCase().indexOf(props.text.toLowerCase()) !== -1}
              onChange={selected => this.setState({ Gender: selected[0]?.Code || "" })}
              options={genders}
              selected={this.state.Gender !== "" ? [genders.find((el) => el?.Code == this.state.Gender) || genders[0]] : []}
              placeholder="Select">
              <Button variant="toggle" onClick={() => { this.genderTypeahead.current?.toggleMenu() }}>
                <FaAngleDown />
              </Button>
            </Typeahead>
          </div>
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>DATE OF BIRTH</Form.Label>
        <Col md={9}>
          <DatePicker className="form-control"
            ref={this.birthdate}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            maxDate={new Date()}
            selected={this.state.DOB as Date}
            enableTabLoop={false}
            onKeyDown={(e) => { if (this.birthdate && this.birthdate.current && e.key === 'Tab') { this.birthdate.current.setOpen(false) } }}
            onChange={date => this.setState({ DOB: date as Date || undefined })}
            customInput={<BirthdayInput />} />
        </Col>
      </Form.Row>
      <Row><Col><h5>CONTACT INFO</h5></Col></Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>ADDRESS LINE 1</Form.Label>
        <Col md={9}>
          <Form.Control type="text" value={this.state.Address1} onChange={(e) => { this.setState({ Address1: e.target.value }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>ADDRESS LINE 2</Form.Label>
        <Col md={9}>
          <Form.Control type="text" value={this.state.Address2} onChange={(e) => { this.setState({ Address2: e.target.value }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>CITY</Form.Label>
        <Col md={9}>
          <Form.Control type="text" value={this.state.City} onChange={(e) => { this.setState({ City: e.target.value }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>STATE</Form.Label>
        <Col md={9}>
          <StateSelect states={this.state.states} dropButtonIfInvalid selectedCode={this.state.state?.Abbreviation} onChange={(state) => this.handleStateChange(state)} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>ZIP</Form.Label>
        <Col md={9}>
          <Form.Control type="text" value={this.state.Zip} onChange={(e) => { this.setState({ Zip: FormatZipCode(e.target.value) }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>PROVINCE</Form.Label>
        <Col md={9}>
          <Form.Control type="text" value={this.state.Province} onChange={(e) => { this.setState({ Province: e.target.value }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>WORK PHONE</Form.Label>
        <Col md={9}>
          <PhoneNumberMaskedInput value={this.state.WPhone} onChange={(value: string) => this.handlePhoneChange(value, "WPhone", "isWorkPhoneValid")} isInvalid={!this.state.isWorkPhoneValid} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>HOME PHONE</Form.Label>
        <Col md={9}>
          <PhoneNumberMaskedInput value={this.state.HPhone} onChange={(value: string) => this.handlePhoneChange(value, "HPhone", "isHomePhoneValid")} isInvalid={!this.state.isHomePhoneValid} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>MOBILE PHONE</Form.Label>
        <Col md={9}>
          <PhoneNumberMaskedInput value={this.state.CPhone} onChange={(value: string) => this.handlePhoneChange(value, "CPhone", "isMobilePhoneValid")} isInvalid={!this.state.isMobilePhoneValid} />
        </Col>
      </Form.Row>
      <Form.Row className="form-group">
        <Form.Label column sm={3}>EMAIL</Form.Label>
        <Col md={9}>
          <Form.Control type="text" isInvalid={!this.state.isEmailValid} value={this.state.Email} onChange={(e) => { this.setState({ Email: e.target.value, isEmailValid: this.isEmailValid(e.target.value) }) }} />
        </Col>
      </Form.Row>
      <Form.Row className="modal-footer">
        <Button variant="secondary" onClick={() => this.handleClose()}>CANCEL</Button>
        <ActionButton variant="primary" type="submit" disabled={!this.isValid(this.state)} spin={this.props.isSaving} disableOnSpin>SAVE</ActionButton>
      </Form.Row>
    </Form>
  }
}

function mapStateToProps(state: AppState): EmploymentDetailsAuthProps {
  return {
    isLocation: (GetSelectedAssignedClinic(state)?.LocationID || 0) > 0
  }
}
const ConnectedEmploymentDetails = connect(mapStateToProps, null)(EmploymentDetails)
export default ConnectedEmploymentDetails